const $ = require('jQuery')
const Form = require('./utilities/_form-controller.js')

function emailValid (email) {
  // Regex for testing the email
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-\_0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  // Get domain of the email
  var emailDomain = email.substr(email.indexOf('@'));

  // Get list of the blocked emails
  var excludedEmailDomainsPreparation = window.blockedEmailDomains.toString().replace(/\s/g,"");
  var excludedEmailDomains = JSON.parse(excludedEmailDomainsPreparation).split(",");
 
  // Check if the email is in the blocked domain list
  var excludedDomains = !(excludedEmailDomains.indexOf(emailDomain) > -1);

  // Get list of blocked strings
  var excludedEmailStringsPreparation = window.blockedEmailStrings.toString().replace(/\s/g,"");
  var excludedEmailStrings = JSON.parse(excludedEmailStringsPreparation).split(",");

  // Function to find substring in array
  Array.prototype.findFirstSubstring = function(s) {
      for(var i = 0; i < this.length; i++) {
          if(s.indexOf(this[i]) !== -1) {
              return true;
              // If we need specific location / element key
              // return i;
          }
      }
      
      // If no occurrences
      return false;
  };
  
  // Check if the email contains blocked string
  var excludedStrings = !excludedEmailStrings.findFirstSubstring(email);
  
  // Validate the email
  var validEmail = re.test(String(email).toLowerCase());

  // get boolean of whether this is a valid email
  // get boolean of whether this is in the blacklist of email domains
  // get boolean of whether this is in the blacklist of email strings

  return (excludedDomains && validEmail && excludedStrings);
}

$(document).ready(() => $('.itbl-activate-hub-page-events-save-the-date-form').each(function () {
  const $saveTheDateForm = $(this)

  $saveTheDateForm.find('input').on('change', function () {
    $(this).removeClass('invalid')
    $(this).closest('label').removeClass('invalid')
    $saveTheDateForm.find(`.${$(this).attr('name')}-wrap .required-error`).addClass('hide')
  })

  $saveTheDateForm.on('submit', async e => {
    $saveTheDateForm.find('button[type=submit]').attr('disabled', true)

    e.preventDefault()

    const data = {
      munchkinId: '723-YAV-537',
      formid: 1131,
      Email: $saveTheDateForm.find('[name=Email]').val(),
      Country: $saveTheDateForm.find('[name=Country]').val(),
      marketingConsent: $saveTheDateForm.find('[name=marketingConsent]').is(':checked') ? 'true' : 'NULL',
      activateLocation: $saveTheDateForm.find('[name=activateLocation]').val()
    }

    $saveTheDateForm.find('[type=hidden]').each(function () { data[jQuery(this).attr('name')] = jQuery(this).val() })

    let isValid = true

    if (!$saveTheDateForm.find('[name=marketingConsent]').is(':checked')) {
      $saveTheDateForm.find('.marketingConsent-wrap .required-error').removeClass('hide')
      $saveTheDateForm.find('[name=marketingConsent]').closest('label').addClass('invalid')
      isValid = false
    }

    if (!data.Email || !emailValid(data.Email)) {
      $saveTheDateForm.find('[name=Email]').addClass('invalid')
      $saveTheDateForm.find('.Email-wrap .required-error').removeClass('hide')
      $saveTheDateForm.find('[name=Email]').closest('label').addClass('invalid')
      isValid = false
    }

    if (!data.Country) {
      $saveTheDateForm.find('[name=Country]').addClass('invalid')
      $saveTheDateForm.find('[name=Country]').closest('label').addClass('invalid')
      isValid = false
    }

    if (!isValid) {
      $saveTheDateForm.find('button[type=submit]').attr('disabled', false)
      return
    }

    $saveTheDateForm.find('.form').addClass('invisible')
    $saveTheDateForm.find('.itbl-activate-hub-page-events-save-the-date-form-loading').removeClass('hide')
    $saveTheDateForm.find('.itbl-activate-hub-page-events-save-the-date-form-loading').removeClass('invisible')

    try {
      await Form.marketo__submit(data, undefined, undefined, $saveTheDateForm)

      $saveTheDateForm.find('button[type=submit]').attr('disabled', false)
      $saveTheDateForm.find('.itbl-activate-hub-page-events-save-the-date-form-loading').addClass('hide')
      $saveTheDateForm.find('.form').addClass('hide')
      $saveTheDateForm.find('.success').removeClass('hide')
    } catch (e) {
      console.log('An error occurred during form submission', e)
    }
  })
}))
